// Deutsche dayjs-Sprache, app-weit (#206): Kalender beginnen am Montag.
//
// antd liest den ersten Wochentag der DatePicker aus dayjs
// (`dayjs().locale('de').localeData().firstDayOfWeek()`); ohne registrierte
// `de`-Sprache fällt dayjs still auf `en` zurück — Sonntag. Bisher
// registrierte sie nur die lazy geladene ZugangView, der Wochenbeginn hing
// also davon ab, ob man die zuvor geöffnet hatte.
//
// Hier bewusst `dayjs/locale/de` und NICHT `dayjs/esm/locale/de` (umgekehrt
// zum moment-Fall in main.tsx): dayjs hat kein `module`-Feld, `import 'dayjs'`
// landet auf der CJS-Datei, und nur die CJS-Locale `require`t genau diese. Die
// ESM-Locale importiert `dayjs/esm/index` — eine zweite Instanz.
import dayjs from 'dayjs';
import 'dayjs/locale/de';

dayjs.locale('de');
